import statusTrackerModal from "./component/status_tracker_modal";
import transferDossierModal from "./component/transfer_dossier_modal";
import statusTracker from "./component/status_tracker";
import menu from "./component/menu";
import investorPortalOrigin from "./component/investor_portal_origin";
import signatureAlertBanner from "./component/signature_alert_banner";
import form from "./component/form";
import depositDocument from "./component/deposit_document";
import tooltip from "./component/tooltip";
import revenuCharge from "./component/revenu_charge";

export default {
	status_tracker_modal: statusTrackerModal,
	transfer_dossier_modal: transferDossierModal,
	status_tracker: statusTracker,
	menu: menu,
	investor_portal_origin: investorPortalOrigin,
	signature_alert_banner: signatureAlertBanner,
	form: form,
	deposit_document: depositDocument,
	tooltip: tooltip,
	revenu_charge: revenuCharge,
};
